// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N0, N90A } from '@atlaskit/theme/colors';
export var playButtonClassName = 'media-card-play-button';
export var bkgClassName = 'play-icon-background';
var discSize = 48;
var discSizeHover = 56;
export var fixedPlayButtonStyles = "\n  .".concat(bkgClassName, " {\n    width: ").concat(discSizeHover, "px;\n    height: ").concat(discSizeHover, "px;\n  }\n");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var playButtonWrapperStyles = css({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: "var(--ds-icon-inverse, ".concat(N0, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  span: {
    position: 'absolute'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var backgroundStyles = css({
  transitionProperty: 'width, height',
  transitionDuration: '0.1s',
  position: 'absolute',
  width: "".concat(discSize, "px"),
  height: "".concat(discSize, "px"),
  background: "var(--ds-background-neutral-bold, ".concat(N90A, ")"),
  borderRadius: '100%'
});